module.exports = __webpack_public_path__ + "img/3.f0f6b61a.png";